import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload } from "lucide-react";
import { API } from "../data/site";

export const inputCls =
  "w-full bg-white border border-[#1A1A1A]/15 focus:border-[#8C6A4F] outline-none px-3 py-2.5 text-sm rounded-none transition-colors duration-300";

export const Field = ({ label, children, span = 1, testid }) => (
  <label className={`block ${span === 2 ? "md:col-span-2" : span === 3 ? "md:col-span-3" : ""}`} data-testid={testid}>
    <span className="eyebrow text-[#5C5A56] block mb-1">{label}</span>
    {children}
  </label>
);

export const DropZone = ({ onUploaded, accept = "image/*", label = "Drag & drop files here, or click to browse", multiple = true, testid, category }) => {
  const [busy, setBusy] = useState(false);
  const [drag, setDrag] = useState(false);
  const fileRef = useRef(null);

  const uploadFiles = async (files) => {
    if (!files.length) return;
    setBusy(true);
    let ok = 0;
    for (const file of files) {
      try {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await axios.post(`${API}/upload${category ? `?category=${encodeURIComponent(category)}` : ""}`, fd, { withCredentials: true });
        await onUploaded(data.url);
        ok++;
      } catch {
        toast.error(`Failed: ${file.name}`);
      }
    }
    if (ok) toast.success(ok > 1 ? `${ok} files uploaded` : "File uploaded");
    setBusy(false);
    if (fileRef.current) fileRef.current.value = "";
  };

  return (
    <div
      onClick={() => fileRef.current.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); uploadFiles([...e.dataTransfer.files]); }}
      data-testid={testid}
      className={`mt-2 border-2 border-dashed px-4 py-6 text-center cursor-pointer transition-colors duration-300 ${drag ? "border-[#8C6A4F] bg-[#8C6A4F]/5" : "border-[#1A1A1A]/20 hover:border-[#8C6A4F]"}`}
    >
      <input ref={fileRef} type="file" accept={accept} multiple={multiple} className="hidden" onChange={(e) => uploadFiles([...e.target.files])} />
      <Upload size={16} className="mx-auto text-[#8C6A4F] mb-2" />
      <span className="font-mono text-[0.62rem] tracking-[0.15em] uppercase font-bold text-[#5C5A56]">{busy ? "Uploading…" : label}</span>
    </div>
  );
};

export const StatusPill = ({ published, archived, testid }) => (
  <span
    data-testid={testid}
    className={`font-mono text-[0.58rem] tracking-[0.15em] uppercase font-bold px-2.5 py-1 ${
      archived ? "bg-[#4B4B4B] text-white" : published ? "bg-[#4E735B] text-white" : "bg-[#A37C45] text-white"
    }`}
  >
    {archived ? "Archived" : published ? "Published" : "Draft"}
  </span>
);

export const AdminButton = ({ children, onClick, primary = false, danger = false, testid, disabled, type }) => (
  <button
    type={type || (primary ? "submit" : "button")}
    onClick={onClick}
    disabled={disabled}
    data-testid={testid}
    className={`font-mono text-[0.65rem] tracking-[0.18em] uppercase font-bold px-6 py-3 transition-colors duration-300 disabled:opacity-50 ${
      primary
        ? "bg-[#1A1A1A] text-[#F7F5F2] btn-sweep"
        : danger
        ? "border border-red-300 text-red-600 hover:bg-red-600 hover:text-white"
        : "border border-[#1A1A1A]/25 hover:bg-[#1A1A1A] hover:text-white"
    }`}
  >
    {children}
  </button>
);
